import { useNavigate } from 'react-router-dom';
import { Swiper as SwiperType } from 'swiper';
import 'swiper/css';
import 'swiper/css/free-mode';
import { FreeMode } from 'swiper/modules';
import { SwiperSlide } from 'swiper/react';
import { SubTitle } from '~/pages/Main/index.styled';
import { FullScreenLoading } from '~/components/common';
import GameCard from '~/components/common/GameCard/GameCard';
import { SwiperContainer } from '~/components/common/HorizontalCardSlide/HorizontalCardSlide';
import {
  useGetListByCharacterTypeQuery,
  useGetMissionGameListQuery,
} from '~/features/character';
import { useCreateChatRoom } from '~/hooks';
import { GameData } from '~/types/missionGameApi';
import { PAGE_ROUTE } from '~/constants';

export default function GameSection() {
  const navigate = useNavigate();

  const { data: characterCardList } = useGetListByCharacterTypeQuery({
    type: 'mystery',
  });

  const { handleCreateRoomClick, isCreateRoomPending } = useCreateChatRoom();

  const handleMissionGameClick = ({
    gameData,
    pageTo,
  }: {
    gameData: GameData;
    pageTo: 'detail' | 'main';
  }) => {
    const gameEnterRouteUrl = `${PAGE_ROUTE.MISSION_GAME}/${pageTo}/${gameData.game_id}`;
    navigate(gameEnterRouteUrl);
  };

  const {
    data: missionGameList,
    isFetchingNextPage: isFetchingNextCard,
    fetchNextPage: fetchNextMissionGameCard,
    hasNextPage: hasNextMissionGameCard,
  } = useGetMissionGameListQuery();

  const handleSlideChange = (swiper: SwiperType) => {
    const totalMissionGameSlides = missionGameList.pages.length;
    const currentIndex = swiper.activeIndex;

    // 현재 보이는 슬라이드가 미션게임 데이터의 마지막에서 5개 이내일 때 다음 페이지 로드
    if (
      currentIndex >= totalMissionGameSlides - 5 &&
      !isFetchingNextCard &&
      hasNextMissionGameCard
    ) {
      fetchNextMissionGameCard();
    }
  };

  return (
    <>
      {/* {isCreateRoomPending && <FullScreenLoading />} */}

      <div>
        <div style={{ marginBottom: 16 }}>
          <SubTitle># Game play</SubTitle>
        </div>

        {/* Game Play Carousel Section */}
        <SwiperContainer
          spaceBetween={12}
          slidesPerView={'auto'}
          freeMode={true}
          modules={[FreeMode]}
          onSlideChange={handleSlideChange}
        >
          {missionGameList.pages?.map((el) => (
            <SwiperSlide
              key={el.game_id}
              style={{ width: `210px`, cursor: 'pointer' }}
            >
              <GameCard
                key={`MissionGameCard_${el.game_id}`}
                game_id={String(el.game_id)}
                create_username={el.create_username}
                liked_count={el.liked_count}
                thumbnail_file_path={el.thumbnail_file_path}
                title={el.title}
                handleCardClick={() =>
                  handleMissionGameClick({ gameData: el, pageTo: 'detail' })
                }
                handlePlayGameClick={() =>
                  handleMissionGameClick({ gameData: el, pageTo: 'main' })
                }
              />
            </SwiperSlide>
          ))}
          {characterCardList.map((el) => (
            <SwiperSlide
              key={el.character_id}
              style={{ width: `210px`, cursor: 'pointer' }}
            >
              <GameCard
                key={`CharacterCard_${el.character_id}`}
                game_id={el.character_id}
                create_username={el.create_username}
                liked_count={el.liked_count}
                thumbnail_file_path={el.character_image}
                title={el.character_desc}
                handleCardClick={handleCreateRoomClick}
              />
            </SwiperSlide>
          ))}
        </SwiperContainer>
      </div>
    </>
  );
}
